import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, Nav, NavItem, NavLink, TabContent, TabPane
} from 'reactstrap'

class DownloadModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'welds',
      weldFormat: 'xlsx',
      ndtInspectionType: props.inspectionTypes && props.inspectionTypes.length > 0 ? props.inspectionTypes[0].id || '' : '',
      scope: 'all'
    }
  }

  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    inspectionTypes: PropTypes.array
  }

  componentDidUpdate(prevProps) {
    if ((!prevProps.inspectionTypes || !prevProps.inspectionTypes.length) && this.props.inspectionTypes && this.props.inspectionTypes.length && !this.state.ndtInspectionType) {
      this.setState({ ndtInspectionType: this.props.inspectionTypes[0].id })
    }
  }

  handleConfirm() {
    this.props.onConfirm(this.state)
  }

  render() {
    const { isOpen, toggle, inspectionTypes = [] } = this.props
    const { activeTab, weldFormat, ndtInspectionType, scope } = this.state

    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Export</ModalHeader>
        <ModalBody>
          <Nav tabs className="mb-3">
            {['welds', 'ndt', 'report'].map(tab => (
              <NavItem key={tab}>
                <NavLink
                  active={activeTab === tab}
                  onClick={() => this.setState({ activeTab: tab })}
                  style={{ cursor: 'pointer' }}
                >
                  <b>{tab === 'ndt' ? 'NDT' : tab.charAt(0).toUpperCase() + tab.slice(1)}</b>
                </NavLink>
              </NavItem>
            ))}
          </Nav>

          <TabContent activeTab={activeTab} style={{ border: 'none' }}>
            <TabPane tabId="welds" style={{ paddingTop: '10px' }}>
              <div className="form-check mb-1">
                <input id="weld-xlsx" className="form-check-input" type="radio" name="weldFormat" checked={weldFormat === 'xlsx'}
                  onChange={() => this.setState({ weldFormat: 'xlsx' })} />
                <label htmlFor="weld-xlsx" className="form-check-label">Microsoft Excel (xlsx)</label>
              </div>
              <div className="form-check">
                <input id="weld-csv" className="form-check-input" type="radio" name="weldFormat" checked={weldFormat === 'csv'}
                  onChange={() => this.setState({ weldFormat: 'csv' })} />
                <label htmlFor="weld-csv" className="form-check-label">Comma Separated Values (csv)</label>
              </div>
            </TabPane>

            <TabPane tabId="ndt" style={{ paddingTop: '10px' }}>
              <div className="d-flex align-items-center">
                <div className="form-check">
                  <input id="ndt-order" className="form-check-input" type="radio" name="ndtType" defaultChecked />
                  <label htmlFor="ndt-order" className="form-check-label">Inspection Order</label>
                </div>
                <select className="form-control form-control-sm ml-2" style={{ width: 'auto' }}
                  value={ndtInspectionType}
                  onChange={e => this.setState({ ndtInspectionType: e.target.value })}>
                  {inspectionTypes.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                </select>
              </div>
            </TabPane>

            <TabPane tabId="report" style={{ paddingTop: '10px' }}>
              <div className="form-check">
                <input id="report-xlsx" className="form-check-input" type="radio" name="reportFormat" defaultChecked />
                <label htmlFor="report-xlsx" className="form-check-label">Report - Microsoft Excel (xlsx)</label>
              </div>
            </TabPane>
          </TabContent>


          <div style={{ display: 'flex', gap: '16px', marginTop: '16px', paddingLeft: '15px' }}>
            <div className="form-check">
              <input id="scope-all" className="form-check-input" type="radio" name="scope" checked={scope === 'all'}
                onChange={() => this.setState({ scope: 'all' })} />
              <label htmlFor="scope-all" className="form-check-label">All</label>
            </div>
            <div className="form-check">
              <input id="scope-filtered" className="form-check-input" type="radio" name="scope" checked={scope === 'filtered'}
                onChange={() => this.setState({ scope: 'filtered' })} />
              <label htmlFor="scope-filtered" className="form-check-label">Filtered</label>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>Cancel</Button>
          <Button color="primary" onClick={() => this.handleConfirm()}>Export</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default DownloadModal



// WEBPACK FOOTER //
// ./src/components/Projects/DownloadModal.js